import React, { useCallback } from 'react';
import { UNARY_SELECTOR_TEXT } from '../constants';
import { DirectiveData } from '../interfaces';
import { SelectorInput, SelectorChangeEvent } from './SelectorInput';

interface ColorAtomSelectorProps {
  /** Directive data object containing type and parameters */
  directiveData: DirectiveData;
  /** Callback when directive data is updated */
  onUpdate: (updates: Partial<Omit<DirectiveData, 'id'>>) => void;
}

/**
 * Minimal React component for atom color directive.
 * Includes selector input and color picker.
 */
export const ColorAtomSelector: React.FC<ColorAtomSelectorProps> = (props: ColorAtomSelectorProps) => {
  const handleInputChange = (event: SelectorChangeEvent | React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    props.onUpdate({
      params: {
        ...props.directiveData.params,
        [name]: value
      }
    });
  };

  return (
    <>
      <div className="field-group">
        <label className="field-label infolabel" title={UNARY_SELECTOR_TEXT}>
          Selector
        </label>
        <SelectorInput
          name="selector"
          value={props.directiveData.params.selector as string || ''}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="field-group">
        <label className="field-label">Color</label>
        <input
          type="color"
          name="value"
          value={props.directiveData.params.value as string || '#000000'}
          onChange={handleInputChange}
          required
        />
      </div>
    </>
  );
};
